export default __webpack_public_path__ + "static/media/manufacture.6dee51ba.svg";